var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VApp',[_c('Loader',[_c('Transition',{attrs:{"name":"fade","mode":"out-in"}},[_c(_vm.layout,{tag:"Component",class:{ 'in-route-transition': _vm.inRouteTransition }},[_c('ExtendedRouterView')],1)],1),_c('DialogUpdate')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }